<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-27 11:16:00
 * @FilePath: /wemeet-admin-new/src/views/brand/categoryList.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button :icon="Plus" type="primary" @click="addEnter()">添加类目分组</el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="12">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item>
            <el-input v-model.trim="queryForm.likeExhibitorName" clearable placeholder="请输入机构列表名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
      <el-table-column label="序号" type="index" width="50" />
      <el-table-column label="类目分组名称" prop="name" show-overflow-tooltip />
      <el-table-column label="类目数量" prop="categoryNames" show-overflow-tooltip />
      <el-table-column label="操作" show-overflow-tooltip width="520">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleAddCategoryItem(row)">配置类目</el-button>
          <el-button plain type="info" @click="addEnter(row)">编辑</el-button>
          <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />

    <edit ref="editRef" :group-id="queryForm.groupId" @fetch-data="fetchData" />

    <addCategoryItem ref="addCategoryItemRef" :group-id="queryForm.groupId" @fetch-data="fetchData" />

    <addEnterpriseInfoByCategory
      ref="addEnterpriseInfoByCategoryRef"
      :group-id="queryForm.groupId"
      @fetch-data="fetchData"
    />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { queryEnterpriseCategoryGroup, delEnterpriseCategoryGroup } from '@/api/enterPriseApi'
  import { useRoute } from 'vue-router'
  import addCategoryItem from './components/addCategoryItem.vue'
  import addEnterpriseInfoByCategory from './components/addEnterpriseInfoByCategory.vue'
  export default defineComponent({
    name: 'Brand',
    components: {
      Edit: defineAsyncComponent(() => import('./components/editCategory.vue')),
      addCategoryItem,
      addEnterpriseInfoByCategory,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          likeExhibitorName: '',
          pageNum: 1,
          pageSize: 10,
          meetingCode: route.query.meetingCode,
          groupId: route.query.groupId,
        },
        activeName: 'first',
        exportPosterRef: null,
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        productUploadRef: null,
        chooseVal: [],
        fullscreenLoading: false,
        dialogVisible: false,
        posterUrl: '',
        checkRow: {},
        addCategoryItemRef: null,
        addEnterpriseInfoByCategoryRef: null,
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await delEnterpriseCategoryGroup(row.id)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.groupId = route.query.groupId
        const { data } = await queryEnterpriseCategoryGroup(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const shopStatusChange = async (row) => {
        try {
          let obj = {
            status: row.status,
            exhibitorCode: row.exhibitorCode,
          }
          await editBrandStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
          console.log(e)
        }

        fetchData()
      }

      onMounted(() => {
        fetchData()
      })

      const addEnter = (row) => {
        state.editRef.handleOpen(row)
      }

      const handleAddCategoryItem = (row) => {
        state.addCategoryItemRef.handleOpen(row)
      }

      const handleCopy = () => {
        proxy.$baseConfirm('请确认要复制并生成一个新的机构列表', null, async () => {
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        })
      }

      const batchEnterprise = (row) => {
        state.addEnterpriseInfoByCategoryRef.handleOpen(row)
      }
      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        shopStatusChange,
        handleConfig,
        Delete,
        Search,
        Plus,
        addEnter,
        handleCopy,
        handleAddCategoryItem,
        batchEnterprise,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
